var exports = {
  "kL": "ChannelChatLayout.module__container___d0VDZz",
  "Yx": "ChannelChatLayout.module__messagesArea___d0VDZz",
  "gA": "ChannelChatLayout.module__textareaArea___d0VDZz",
};

module.exports = exports;
